export const PAGE_SIZE_DEFAULT = 30

export enum TableLocalStorageKey {
  filters = "filters",
  pageSize = "pageSize",
  sortModel = "sortModel",
  visibleColumns = "visibleColumns",
  order = "order"
}

export const setLocalStorageValues = (tableId: string, key: TableLocalStorageKey, value: any) => {
  try {
    const storedValue = JSON.parse(localStorage.getItem(tableId) || "{}") || {}

    storedValue[key] = value

    localStorage.setItem(tableId, JSON.stringify(storedValue))
  } catch {
    // empty
  }
}
export const getLocalStorageValues = (tableId: string, key: TableLocalStorageKey) => {
  try {
    if (!tableId) {
      return null
    }

    const storedValue = JSON.parse(localStorage.getItem(tableId) || "{}")

    if (!storedValue) {
      return null
    }

    return storedValue[key]
  } catch {
    // empty
  }
}

export const getPageSizeValue = (tableId: string) => {
  const storedValue = getLocalStorageValues(tableId, TableLocalStorageKey.pageSize)

  return storedValue || PAGE_SIZE_DEFAULT
}
